import { PointageDashboardView } from "@features/home-dashboard/pointage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/(dashboard)/pointage/me/")({
  staticData: {
    title: "Feuille de Temps",
    section: "Général",
    order: 40,
    showInTab: true,
    showInBreadcrumb: true,
  },
  component: PointageMeRoute,
});

function PointageMeRoute() {
  return <PointageDashboardView />;
}
